export const boundaryLevelLookUp: {
  '0': string[]
  '1': string[]
  '2': string[]
  '3': string[]
} = {
  '0': ['MS_zz-countries'],
  '1': ['MS_us-states', 'MS_uk-regions', 'MS_au-states'],
  '2': ['MS_us-counties', 'MS_uk-lads', 'MS_au-gdas'],
  '3': ['MS_us-zipcodes', 'MS_uk-msoas', 'MS_au-postcodes']
}
